/* global axios */
import ApiClient from './ApiClient';

// O recorte da página Atendimento, como a API o recebe. since/until: 'YYYY-MM-DD',
// inclusivos, no fuso da conta. Filtro vazio é "todos" e não vai na query.
// `userId` é o atendente; `agentId`, o agente de IA (PowerAgent).
export const queryParams = ({
  since,
  until,
  includeTests = false,
  agentId,
  inboxId,
  teamId,
  userId,
} = {}) => ({
  since,
  until,
  include_tests: includeTests,
  agent_ids: agentId ? [agentId] : undefined,
  inbox_id: inboxId || undefined,
  team_id: teamId || undefined,
  user_id: userId || undefined,
});

// Uma rota por seção: cada seção pede a sua, e a falha de uma não apaga as outras.
// O custo só vem na resposta de super admin — quem corta é o servidor.
class AtendimentoAPI extends ApiClient {
  constructor() {
    super('atendimento', { accountScoped: true });
  }

  section(name, filters, extra = {}) {
    return axios.get(`${this.url}/${name}`, {
      params: { ...queryParams(filters), ...extra },
    });
  }

  agora(filters) {
    return this.section('agora', filters);
  }

  // As conversas de uma linha da Agora (waiting | stalled | with_ai |
  // with_person | outbound_replied), de 25 em 25. A pessoa da linha vai em
  // `person_id`; o `user_id` do filtro segue sendo o atendente da página, e os
  // dois se somam.
  agoraConversas(filters, line, { page = 1, personId } = {}) {
    return this.section('agora/conversas', filters, {
      line,
      person_id: personId || undefined,
      page,
    });
  }

  // O filtro "Origem" (`origin`: client | outbound) e o "Abrir por" (`by`:
  // agent | inbox | team | user) são só do Caminho: nenhuma outra seção os manda.
  caminho(filters, { origin, by } = {}) {
    return this.section('caminho', filters, { origin, by });
  }

  // As conversas de uma linha do caminho, de 25 em 25, na origem do Caminho.
  conversas(filters, line, page = 1, { origin } = {}) {
    return this.section('conversas', filters, { line, page, origin });
  }

  ia(filters) {
    return this.section('ia', filters);
  }

  // As chamadas de ferramenta do runtime: as que falharam, para "A IA", e a
  // tarefa concluída do caminho. Rota à parte: as outras seções não esperam por ela.
  // A tarefa concluída segue a origem do Caminho (senão passaria de "Terminou sem
  // pessoa"); a lista de "A IA" não a lê.
  ferramentas(filters, { origin } = {}) {
    return this.section('ferramentas', filters, { origin });
  }

  equipe(filters) {
    return this.section('equipe', filters);
  }

  // by: inbox | team | user | agent
  comparar(filters, by = 'inbox') {
    return this.section('comparar', filters, { by });
  }

  fora(filters) {
    return this.section('fora', filters);
  }

  // A Números (REPORTS-04), com a série por balde: `agrupar` é dia | semana |
  // mes. Os mapas de calor vêm à parte, porque não dependem do agrupamento.
  numeros(filters, agrupar = 'dia') {
    return this.section('numeros', filters, { agrupar });
  }

  mapa(filters) {
    return this.section('mapa', filters);
  }
}

export default new AtendimentoAPI();
